<template>
    <Confirm v-if="Show" @close="Cancel">
        <template v-slot:icon>
            <div style="float:left;margin:12px;">
                <img class="icon" :style="{width: '50px', height:'50px'}" :src="this.getIconPath(icon)" />
            </div>
        </template>

        <template v-slot:body>
            <div :style="useModalDialogsV2 ? 'white-space: normal;' : 'padding-top:15px; white-space: normal;'">{{title}}</div>
            <div v-if="innerHtml" :style="useModalDialogsV2 ? 'max-height: 300px; overflow: auto' : 'max-height: 300px; padding: 20px; overflow: auto'">
                <div v-html="innerHtml"></div>
            </div>
        </template>

        <template v-slot:footer>
            <CommonButton v-if="nullButtonText!=null"
                            :type="ButtonType.Default"
                            :text="nullButtonText"
                            @click="Null"/>
            <CommonButton v-if="hideCancelButton!=true"
                            :type="ButtonType.Default"
                            :text="cancelButtonText == null ? Localizer.Localize('Cancel_PascalCase'): cancelButtonText"
                            @click="Cancel"/>
            <CommonButton
                            :type="ButtonType.Primary"
                            :text="acceptButtonText == null ? Localizer.Localize('Ok_PascalCase') : acceptButtonText"
                            @click="Accept"/>
        </template>
    </Confirm>
</template>

<script lang="ts">
    import { Localizer } from "../../api/Localizer";
    import Confirm from './Confirm.vue';
    import { Component, Prop, Vue } from 'vue-facing-decorator';
    import CommonButton from "@/components/helpers/CommonButton.vue";
    import { ButtonType } from "@/components/helpers/HelpersInterface";
    import { detectBasePath, resolveWithBase } from "@/utils/pathUtils";

    @Component({ components: { Confirm, CommonButton } })
    export default class Confirm2 extends Vue {
        private Localizer = new Localizer(this.$store);

        @Prop() title!: string;
        @Prop({ type: String, required: false }) icon!: string | null;
        @Prop() acceptButtonText!: string;
        @Prop() cancelButtonText!: string;
        @Prop() nullButtonText!: string;
        @Prop({ type: String, required: false }) innerHtml!: string | null;
        @Prop() hideCancelButton!: boolean;

        Show: boolean = false;
        ButtonType = ButtonType;
        get useModalDialogsV2(): boolean { return this.$store.state.security.ModalDialogsFeatureFlagValue; }
        
        private resolve: ((value: boolean | null | PromiseLike<boolean | null>) => void) | null = null;
        private getIconPath(iconPath: string): string {
            if (!iconPath) {
                iconPath = '/icons/info.png';
            }
            return resolveWithBase(iconPath);
        }
        Open(): Promise<boolean | null> {
            this.Show = true;

            return new Promise((resolve) => {
                this.resolve = resolve;
            });
        }

        Cancel() {
            this.resolve!(false);
            this.Show = false;
        }

        Accept() {
            this.resolve!(true);
            this.Show = false;
        }

        Null() {
            this.resolve!(null);
            this.Show = false;
        }
    }
</script>

<style scoped>

</style>
